<template>
  <div class="header">
    <div class="header__logo" v-if="screen.breakPoint.smallDesktop" @click="$router.push({ name: 'dashboard' })">
      <svg class="header__logo-icon">
        <use xlink:href="#icon-logo-planet"></use>
      </svg>
    </div>
    <burger v-model="showLeftSidebar" v-else></burger>
    <div class="ml-auto"></div>

    <div class="d-flex align-center justify-end">
      <language-control class="mr-2"></language-control>
      <chat-control v-if="showChat" class="mr-2"></chat-control>
      <!--    <settings-control v-model="vModel" @click="$emit('showSettings')" v-show="!vModel"></settings-control>-->
      <!--    <burger v-model="vModel" @click.native="$emit('showSettings')" v-show="vModel"></burger>-->
      <notify-control class="mr-2"></notify-control>
      <settings-control @click="settingsClick"></settings-control>
    </div>

    <profile v-model="showProfile" :profile="profile"></profile>
  </div>
</template>

<script>
import Burger from '@/ui/controls/Burger'
import ChatControl from '@/ui/controls/ChatControl'
import NotifyControl from '@/ui/controls/NotifyControl'
import SettingsControl from '@/ui/controls/SettingsControl'
import LanguageControl from '@/ui/controls/LanguageControl'
import Profile from '@/components/Profile'

import screen from '@/mixins/screen'
import vModel from '@/mixins/vModel'
import sidebars from '@/mixins/sidebars'
import profile from '@/mixins/profile'

import { Capacitor } from '@capacitor/core'

export default {
  mixins: [vModel, screen, sidebars, profile],

  components: {
    Burger,
    ChatControl,
    NotifyControl,
    SettingsControl,
    LanguageControl,
    Profile
  },

  data () {
    return {
      showProfile: false,

      showChat: !Capacitor.isNativePlatform()
    }
  },

  methods: {
    settingsClick () {
      this.showProfile = true
    }
  }
}
</script>

<style lang="scss">
.header {
  height: $header-height;
  background-color: $color-white;

  display: flex;
  align-items: center;

  padding-left: $default-spacing-mobile;
  padding-right: $default-spacing-mobile;

  @include respond(tab-port) {
    padding-left: $default-spacing;
    padding-right: $default-spacing;
  }

  &__logo {
    cursor: pointer;

    &-icon {
      height: 2.9rem;
      width: 12.1rem;
      padding-top: 0.4rem;
    }
  }
}
</style>
